import { MenuItem, Select, Stack, Typography } from '@rossum/ui/material';
import { useIntl } from '../ComponentsContext';

type Props = {
  pageSize: number | undefined;
  setPageSize: (pageSize: number) => void;
  options: readonly [number, ...number[]];
};

export const PageSizeSelect = ({ pageSize, options, setPageSize }: Props) => {
  const intl = useIntl();
  const currentValue = options.find(value => value === pageSize) ?? options[0];

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Select
        key={currentValue}
        onChange={event => setPageSize(event.target.value)}
        id="pageSizeSelector"
        value={currentValue}
        size="small"
      >
        {options.map(option => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
      <Typography variant="body2">
        {intl.formatMessage({
          id: 'containers.annotationList.paginatorSelector.unit',
        })}
      </Typography>
    </Stack>
  );
};
